import { BikeFastIcon } from './BikeFastIcon';

/**
 * author: GreenTurtwig
 * id 2C312B6E-73D4-4A98-A701-D49E31F95E7B
 * name bike-fast
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bike-fast.svg
 * tags
 * - Transportation + Other 
 * - Sport 
 */
export const VelocityIcon = BikeFastIcon;
export default VelocityIcon